export const getDataFactoryUserAdvancedList = async (customerInput, client) => {
    const response = await fetch(`${client.url}/person/advanced`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Api-Key": `${client.apiKey}`,
        },
        cache: "no-cache",
        signal: AbortSignal.timeout(10_000),
        body: JSON.stringify({
            name: "FullForm",
            operator: "AND",
            properties: [
                {
                    name: "FIRSTNAME",
                    value: customerInput.firstName ?? "",
                },
                {
                    name: "LASTNAME",
                    value: customerInput.lastName ?? "",
                },
                {
                    name: "BORN",
                    value: customerInput.birthDate ?? "",
                },
                {
                    name: "PHONE",
                    value: customerInput.phone ?? "",
                },
            ],
        }),
    });
    if (!response.ok) {
        console.error(`Failed to retrieve customer in DataFactory. Status: ${response.statusText}`);
        return null;
    }
    const data = (await response.json());
    return data;
};
